import { render, staticRenderFns } from "./PatientInfo.vue?vue&type=template&id=f5fa73fa&scoped=true"
import script from "./PatientInfo.vue?vue&type=script&lang=js"
export * from "./PatientInfo.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f5fa73fa",
  null
  
)

export default component.exports